import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import FeedTable from '@app/components/apps/FeedProduction/FeedComponent';

export const EditFeedProduction: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Feed Production');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/feed-productions',
      breadcrumbName: 'Feed Productions',
    },
    {
      path: `/edit-feed-production/${id}`,
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FeedTable
            type={'edit'}
            editable={true}
            id={id}
            pageTitle={`Edit Feed Production`}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditFeedProduction;
